import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Message, SpinnerService } from "shared-components";
import { ExpedicionesService } from '../../services/expediciones.service';

@Component({
  selector: "app-trazabilidad-certificado",
  templateUrl: "./trazabilidad-certificado.component.html",
})

export class TrazabilidadCertificadoComponent implements OnInit {
  public filtersVisible = true;
  public filtersForm: UntypedFormGroup;

  public trazabilidadCertificado;

  // Componente stepper
  public steps = [
    'trazabilidadCertificado.report.procesoCultivo',
    'trazabilidadCertificado.report.procesoDesignacion',
    'trazabilidadCertificado.report.procesoConfeccion',
    'trazabilidadCertificado.report.procesoExpedicion'
  ];
  public icons = [
    'fas fa-seedling i-cultivo',
    'fas fa-handshake i-designacion',
    'fas fa-boxes-stacked i-confeccion',
    'fas fa-truck i-expedicion'
  ];
  // Desplegables anidados del stepper (se prepara para posibles nuevos desplegables en un futuro)
  public parentPosition: number;
  public blockchainInfoHeight: number;
  public blockchainAction: string;

  public mensajes = new Array<Message>();
  public showError: boolean;
  public showWarning: boolean;

  constructor(
    private readonly _translate: TranslateService,
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _expedicionesService: ExpedicionesService,
  ) {}

  ngOnInit(): void {
    this.filtersForm = this._fb.group({
      numCertificado: ['', Validators.required],
    });

    // Comprobación en caso de que en un futuro se lleve a esta página desde un QR ??
    if (!this.filtersForm.get('numCertificado').value) {
      this.showWarning = true;
      this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
    }
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public checkValuesForm(): boolean {
    return this.filtersForm.get('numCertificado').value;
  }

  public resetForm() {
    this.filtersForm.reset();
    this.showWarning = true;
    this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
  }

  private applyFilters(num) {
    this._spinnerService.showSpinner();
      this._expedicionesService.getTrazabilidadCertificado(num).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
      }).then((resp) => {
        this.trazabilidadCertificado = resp;
      }, (error) => {
        this.showError = true;

        if (error.status === 420 && error.error.ApiErrorCode === 6235) {
          this.mensajes.push({ class: 'error', message: 'trazabilidadCertificado.error.noAccesible' });
        } else {
          this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        }
      });
  }

  public filtrar() {
    if (this.filtersForm.invalid) {
      this.showError = true;
      this.mensajes.push({ class: 'error', message: 'global.error.required' });

      // TO-DO: añadir validación minLength y maxLength ??
    } else {
      const num = this.filtersForm.get('numCertificado')?.value;
      this.applyFilters(num);
    }
  }

  /**
     * Expandir o contraer los datos del blockchain
     * 
     * @param parentIndex La posisión del .step-content que se envía al componente stepper
     * @param accordionSection El apartado en que se encuentra el acordeón: Cultivo, Designación o Confección
     */
    public showOrHideData(parentIndex: number, accordionSection: string) {
        const blockchainContainer = document.getElementsByClassName(`blockchain-container-${accordionSection}`)[0] as HTMLElement;
        const blockchainTitle = document.getElementsByClassName(`blockchain-title-${accordionSection}`)[0] as HTMLElement;
        const blockchainArrow = document.getElementsByClassName(`blockchain-arrow-${accordionSection}`)[0] as HTMLElement;
        const blockchainData = document.getElementsByClassName(`blockchain-content-${accordionSection}`)[0] as HTMLElement;
        let titleHeight;
        let dataHeight;      
        
        if (blockchainTitle) {
            titleHeight = blockchainTitle.offsetHeight;
        }
        if (blockchainData) {
            dataHeight = blockchainData.offsetHeight;
        }

        // Desplegamos los datos del blockchain
        if (blockchainContainer.classList.contains('collapsed')) {
            blockchainContainer.classList.remove('collapsed');
            blockchainArrow.style.transform = 'rotate(-180deg)';
            blockchainContainer.style.height = titleHeight + dataHeight + "px";
            this.blockchainInfoHeight = dataHeight;
            this.parentPosition = parentIndex;
            this.blockchainAction = `open${accordionSection}`;
        // Contraemos los datos
        } else if (!blockchainContainer.classList.contains('collapsed')) {
            blockchainContainer.classList.add('collapsed');
            blockchainArrow.style.transform = 'rotate(0)';
            blockchainContainer.style.height = titleHeight + "px";
            this.parentPosition = parentIndex;
            this.blockchainAction = `close${accordionSection}`;
        }
    }
  
  public getBlockchainLink(txId: string): string {
    const baseUrl = 'https://explore.vechain.org/';
    return txId ? `${baseUrl}transactions/${txId}` : baseUrl;
  }
}